import WildAppResource from "./WildAppResource";
import LuStateAppResource from './LuStateAppResource';
import LuDisclosureFormPreferenceAppResource from './LuDisclosureFormPreferenceAppResource';
import TierAppResource from './TierAppResource';
import FileAppResource from './FileAppResource';

class BrokerAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'broker';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'brokers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'agentsAllowedToCreateOrdersInPortal',
            'upsellHslpOnSellerLanding',
            'agentsMustPayForHslp',
            'allOrdersIncludeHslp',
            'isBrokerage',
            'isPremiumBroker',
            'allOrdersUseTar',
            'agentVerificationCode',
            'billingContactEmailAddress',
            'companyName',
            'companyNameAccordingToTheAuthority',
            'developerSecret',
            'humanFirstName',
            'humanLastName',
            'humanTitle',
            'humanQuote',
            'licenseId',
            'urlSlug',
            'website',
            'zohoId',
            'disclosureFormPreferenceId',
            'stateId',
            'tiers',
            'phone',
            'streetAddress',
            'city',
            'zip',
            'avatarFileUuid',
            'logoFileUuid',
            'freePackage',
            'ssBrokerKey',
            'ssBrokerEntityKey',
            'integrations',
            'referringPlatform',
            'referringPlatforms',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            disclosureFormPreference: LuDisclosureFormPreferenceAppResource,
            state: LuStateAppResource,
            tiers: TierAppResource,
            avatarFile: FileAppResource,
            logoFile: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            disclosureFormPreference: 'disclosure_form_preference_id',
            state: 'state_id',
            avatarFile: 'avatar_file_uuid',
            logoFile: 'logo_file_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            billingContactEmailAddress: {
                type: 'string',
                email: true,
                presence: true,
                length: {
                    maximum: 255,
                    minimum: 1,
                },
            },
            companyName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                    minimum: 1,
                },
            },
            phone: {
                type: 'string',
                format: {
                    pattern: '^([0-9-. \(\)\+]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            website: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            agentVerificationCode: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                    minimum: 1,
                },
            },
            stateId: {
                presence: true,
            },
        };
    }

}

export default BrokerAppResource;
